export const FBCollectionConstant = {
  likes: "likes",
  comments: "comments",
  userPosts: "userPosts",
  replies: "replies",
};
